
import Vue from "vue";
import { Component } from "vue-property-decorator";
import TopNav from "./TopNav.vue";
import { SingularityUIState } from "@/store/modules/singularity";
import TopNavButton from "./TopNavButton.vue";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import IconButton from "@/components/UI/IconButton.vue";
import { singularityStore } from "@/store/store";
import { getFrontendUrl } from "@/lib/document";
import { switchToAdvancedMode } from "@/futurelayer/ui/ui";
import TopNavSave from "./TopNavSave.vue";
import TopNavToggleMobile from "./TopNavToggleMobile.vue";

export type NavLink = {
  panelState?: SingularityUIState["singularityLeftPanel"];
  name: string;
  action?: () => void;
};

@Component({
  components: {
    TopNav,
    TopNavButton,
    TopNavSave,
    Dropdown,
    IconButton,
    TopNavToggleMobile
  }
})
export default class TopNavBuilder extends Vue {
  primaryNav: NavLink[] = [
    { panelState: "page_structure", name: "Build" },
    { panelState: "brand", name: "Brand" },
    { panelState: "page_manager", name: "Pages" },
    { panelState: "publish", name: "Publish" }
  ];

  get singularityDebugPanelOpen() {
    return !!singularityStore.singularityUiState.singularityDebugPanel;
  }

  get isPageStructureOrBrandPanelOpen() {
    return (
      singularityStore.singularityUiState.singularityLeftPanel ===
        "page_structure" ||
      singularityStore.singularityUiState.singularityLeftPanel === "brand"
    );
  }

  toggleSingularityDebugPanel() {
    singularityStore.setSingularityDebugPanel(
      this.singularityDebugPanelOpen ? null : "debug"
    );
  }

  get frontendUrl() {
    return getFrontendUrl();
  }

  openFrontend() {
    const url = this.frontendUrl;
    if (url) {
      window.open(url, "_blank");
    }
  }

  openPageStructure() {
    singularityStore.setSingularityLeftPanel("page_structure");
  }

  toggleAdvancedMode() {
    switchToAdvancedMode();
  }
}
